import { render, staticRenderFns } from "./VocabCardWithLanguage.vue.js?vue&type=template&id=fcf7793a&scoped=true!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VocabCardWithLanguage.vue?vue&type=template&id=fcf7793a&scoped=true"
import script from "./VocabCardWithLanguage.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VocabCardWithLanguage.vue?vue&type=script&lang=js"
export * from "./VocabCardWithLanguage.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VocabCardWithLanguage.vue?vue&type=script&lang=js"
import style0 from "./VocabCardWithLanguage.vue.css?vue&type=style&index=0&id=fcf7793a&prod&scoped=true&lang=css!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VocabCardWithLanguage.vue?vue&type=style&index=0&id=fcf7793a&prod&scoped=true&lang=css"
import style1 from "vue-dialog-drag/dist/vue-dialog-drag.css.css?vue&type=style&index=1&prod&lang=css&external!=!vue-dialog-drag/dist/vue-dialog-drag.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf7793a",
  null
  
)

export default component.exports